import React, { Component } from "react";
import bmcButton from '../../images/bmc-button.svg';

export default class BmcButton extends Component {
    render() {
        return (
            <a href="https://www.buymeacoffee.com/olsiodobashi"
                title="Buy me a coffee" target="_blank" rel="noopener noreferrer"
                className="d-inline-block">
                <img src={bmcButton} alt="Buy me a Coffee" /></a>
        );
    }
}
